module.exports = __webpack_public_path__ + "assets/ed3f8f8a87b82f61fb5a606e5c96cb13.png";